import { objComparatorNumber } from "../utils.js";
import axios from 'axios';
import { endpoint, withGetParams, remoteCreate, remoteModifyPut } from "./utils.js";

export function paymentOrderRootURL(getParams) {
  const url = endpoint("internal/current/paymentorder/");
  return withGetParams(url, getParams);
}

export async function fetchPaymentOrders({ page, itemsPerPage, sortBy }, getParams) {
  const res = await axios.get(paymentOrderRootURL({
    limit: itemsPerPage,
    offset: (page - 1) * itemsPerPage,
    ...getParams
  }), {
    withCredentials: true
  });
  return res.data;
}

export async function sendReceiptPaymentOrder(id, client_email, cc_emails) {
  const payload = {
    client_email: client_email,
    cc: cc_emails,
  };
  const res = await axios.post(paymentOrderRootURL({}) + `${id}/send_receipt/`, payload, {
    withCredentials: true
  });
  return res.data['sent'];
}
